import openSharePlaylist from '../playlist/openSharePlaylist';

const openShareQuiz = (quizId: number) => {
  openSharePlaylist(quizId);
};
export default openShareQuiz;
